module.exports = __webpack_public_path__ + "static/media/icon-customer-edit.064e40d3.svg";